document.addEventListener('DOMContentLoaded', function () {

  /* 1. Scroll-reveal — any element with class="lr-reveal" */
  var revealEls = document.querySelectorAll('.lr-reveal');
  if (revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  /* 2. Header scroll state — adds .scrolled to any [data-lr-header] */
  var header = document.querySelector('[data-lr-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* 3. Mobile nav toggle — [data-lr-burger] shows/hides [data-lr-nav] */
  var burger = document.querySelector('[data-lr-burger]');
  var nav = document.querySelector('[data-lr-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* 4. FAQ accordions — any [data-lr-faq] container with [data-lr-faq-item] children */
  document.querySelectorAll('[data-lr-faq]').forEach(function (faq) {
    var items = faq.querySelectorAll('[data-lr-faq-item]');
    items.forEach(function (item) {
      var question = item.querySelector('[data-lr-faq-q]');
      if (!question) return;
      question.addEventListener('click', function () {
        var wasOpen = item.classList.contains('open');
        items.forEach(function (i) { i.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
      });
    });
  });

});